import { text } from '../ui';

export default function AppHeader({ user, onLogout }) {
  return (
    <div className="flex justify-between items-start mb-4">
      <div className="flex items-center gap-3">
        <img src="/MinIO-Logo-Color.png" alt="MinIO Logo" className="h-8" />
        <h1 className="text-2xl font-bold">On-Call Rotation Tool</h1>
      </div>
      <div className="text-right">
        {user && (
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              {user.picture && (
                <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full" />
              )}
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{user.name}</p>
                <p className={text.hint}>{user.email}</p>
              </div>
            </div>
            <button
              onClick={onLogout}
              className="text-sm text-gray-500 hover:text-gray-700 px-2 py-1 border border-gray-300 rounded hover:bg-gray-50"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
